import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { ReportChart } from '../ReportChart/ReportChart'
import { getReports } from '../../api/axios';
import html2pdf from 'html2pdf.js';
import DownloadIcon from '@mui/icons-material/Download';


const ShowingReports = () => {
  const [params, setParams] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    // Parsiranje URL-a za parametre
    const searchParams = new URLSearchParams(window.location.search);
    const extractedParams = {
      accessToken: searchParams.get('accessToken'),
      startDate: searchParams.get('startDate'),
      endDate: searchParams.get('endDate'),
      employeeId: searchParams.get('employeeId'),
      displayType: searchParams.get('displayType'),
    };

    setParams(extractedParams);
  }, []);

  // Drugi useEffect za pozivanje API-ja nakon što params bude postavljen
  useEffect(() => {
    if (!params) return;

    const fetchData = async () => {
      try {
        const result = await getReports(params);
        setData(result.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [params]);
  console.log("params", params);
  const filteredData = data
    ? data.filter((item) => item.serial === params.employeeId)
    : [];
  console.log(filteredData);

  const dictionary = filteredData.reduce((acc, current) => {
    if (!acc[current.serial]) {
      acc[current.serial] = [];
    }
    acc[current.serial].push(current);
    return acc;
  }, {});

  console.log(dictionary);

      const DrawChart = ({ serial, startDate, endDate }) => {
        const employee = dictionary[serial];
      
        // Proverite da li je employee definisano i da li je niz
        if (!employee || !Array.isArray(employee)) {
          return <div>Loading...</div>;
        }
      
        return (
          <>            
            {ReportChart(employee, params.startDate, params.endDate)}
          </>
        );
      };

      const handleExportPdf = () => {
        const element = document.querySelector('#page');
        const chartElement = element.querySelector('canvas'); // Assuming chart is a canvas element
      
        // Apply scale transformation to the chart
        chartElement.style.transform = 'scale(0.5)'; // Adjust scale factor as needed
        chartElement.style.transformOrigin = 'top left';
      
        // Use html2pdf to generate PDF with scaled chart
        const options = {
          margin: 1,
          filename: 'chart.pdf',
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        };
      
        html2pdf().set(options).from(element).save().then(() => {
          // Remove scale transformation after export
          chartElement.style.transform = 'scale(1)';
        });
      };
      

  return (
    <Box>
    {
       params && params.employeeId && (
        <div>
        <div style={{ maxWidth: '1200px', margin: '0 auto', marginTop: '2%', display: 'block' }} id="page">
          {DrawChart({ serial: params.employeeId })}
        </div>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-end',
            marginTop: 2,
            marginRight: 2
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleExportPdf}
            startIcon={<DownloadIcon />}
            sx={{ position: 'fixed', bottom: 20, right: 20 }}
          >
            Export to PDF
          </Button>
        </Box>
      </div> 
  )
    }  
    </Box>   
  );
};

export default ShowingReports;

/*<TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow className="tableHeader">
                    <TableCell style={{ fontWeight: 'bold' }}>Serijski</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Ime</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Prezime</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Name</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Opis smene</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Start</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>End</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Razlika</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {employee.map((entry, index) => (
                    <TableRow key={index}>
                      <TableCell>{entry.serial}</TableCell>
                      <TableCell>{entry.ime}</TableCell>
                      <TableCell>{entry.prezime}</TableCell>
                      <TableCell>{entry.name}</TableCell>
                      <TableCell>{entry.opis_smene}</TableCell>
                      <TableCell>{entry.start}</TableCell>
                      <TableCell>{entry.end}</TableCell>
                      <TableCell>{entry.razlika}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>*/